<template>
  <main id="main">
    <div class="header_page">
      <p id="title_header_page">شهادتنامه پایان دوره</p>
      <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </div>

    <div class="p-3">
      <div v-if="loading" class="text-center mt-5">
        <p>در حال دریافت معلومات...</p>
      </div>

      <div v-else-if="certificates.length === 0" class="text-center mt-5 text_color_gray">
        شهادتنامه‌ای یافت نشد.
      </div>

      <div v-else>
        <div v-for="(item, index) in certificates" :key="index" class="bg_white rounded-4 p-3 shadow-sm d-flex align-items-center justify-content-between mb-3">
          <div class="d-flex align-items-center gap-3 w-70">
            <img :src="getImageUrl(item.pic)" class="w-35 rounded-3 object-fit-contain" alt="" @error="handleImageError">
            <p>{{ item.title || 'شهادتنامه' }}</p>
          </div>
          <button class="button w-25 p-2 font_small" @click="downloadCertificate(item)">دانلود</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'CertificateView',
  data() {
    return {
      certificates: [],
      loading: false
    }
  },
  mounted() {
    this.fetchCertificates()
  },
  methods: {
    async fetchCertificates() {
      this.loading = true
      try {
        const userId = localStorage.getItem('user_id')
        const formData = createFormData({
          user_id: userId
        })
        
        const response = await apiClient.post('/show_certificate', formData)

        if (response.data.status === 'ok' && response.data.data) {
          this.certificates = response.data.data
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    getImageUrl(pic) {
      if (!pic) return require('@/assets/imgs/knowledge_1.svg')
      if (pic.startsWith('http')) return pic
      return `https://back.ayendaman.org/storage/app/public/uploads/${pic}`
    },
    handleImageError(event) {
      event.target.src = require('@/assets/imgs/knowledge_1.svg')
    },
    async downloadCertificate(item) {
      const url = this.getImageUrl(item.pic)
      const filename = item.title ? `${item.title}.png` : `certificate_${Date.now()}.png`

      try {
        const response = await fetch(url)
        const blob = await response.blob()
        const link = document.createElement("a")
        link.href = URL.createObjectURL(blob)
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
      } catch (error) {
        window.open(url, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.object-fit-contain {
  object-fit: contain;
}
.font_small {
  font-size: 0.8rem;
}
</style>